export default "__VITE_ASSET__jWI3gRJf__"